import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Header_2 from '../headers/Header_2';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import SEO from '../components/Seo';

export const Impressum = () => {

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".imprsum-data h3"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);




    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/impressum?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.impressum-data][populate][Firme_Data][populate]=*&populate[Modul][on][modules.impressum-data][populate][Adresse_Data][populate][Icon_Text][populate][Icon][populate]=*&populate[Metadaten]=*");

            // &populate[Modul][on][modules.impressum-data][populate][Adresse_Data][populate][Icon_Text][populate][Icon][populate]=*


            // &populate[Modul][on][modules.faq][populate][FAQ_Data][populate]=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data?.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    // utils/helper.js

    const convertLinks2 = (text) => {
        if (!text) return text;

        const regex =
            /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|\+?\d[\d\s-]{7,}\d)/g;

        const parts = [];
        let lastIndex = 0;

        [...text.matchAll(regex)].forEach((match, index) => {
            const matchText = match[0];
            const start = match.index;

            // Normal text before match
            if (start > lastIndex) {
                parts.push(text.slice(lastIndex, start));
            }

            // URL
            if (/^https?:\/\//.test(matchText)) {
                parts.push(
                    <a
                        key={index}
                        href={matchText}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {matchText}
                    </a>
                );
            }

            // www URL
            else if (/^www\./.test(matchText)) {
                parts.push(
                    <a
                        key={index}
                        href={`https://${matchText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {matchText}
                    </a>
                );
            }

            // Email
            else if (
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(matchText)
            ) {
                parts.push(
                    <a key={index} href={`mailto:${matchText}`}>
                        {matchText}
                    </a>
                );
            }

            // Phone
            else {
                parts.push(
                    <a
                        key={index}
                        href={`tel:${matchText.replace(/\s|-/g, "")}`}
                    >
                        {matchText}
                    </a>
                );
            }

            lastIndex = start + matchText.length;
        });

        // Remaining text
        if (lastIndex < text.length) {
            parts.push(text.slice(lastIndex));
        }

        return parts;
    };

    const convertLinks = (text) => {
        if (!text) return text;

        const regex =
            /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|\+?\d[\d\s-]{7,}\d)/g;

        const parts = [];
        let lastIndex = 0;

        [...text.matchAll(regex)].forEach((match, index) => {
            const matchText = match[0];
            const start = match.index;

            // Text before match
            if (start > lastIndex) {
                const normalText = text.slice(lastIndex, start);

                // handle line breaks
                normalText.split("\n").forEach((line, i, arr) => {
                    parts.push(line);

                    if (i !== arr.length - 1) {
                        parts.push(<br key={`br-${index}-${i}`} />);
                    }
                });
            }

            // URL
            if (/^https?:\/\//.test(matchText)) {
                parts.push(
                    <a
                        key={index}
                        href={matchText}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {matchText}
                    </a>
                );
            }

            // www URL
            else if (/^www\./.test(matchText)) {
                parts.push(
                    <a
                        key={index}
                        href={`https://${matchText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {matchText}
                    </a>
                );
            }

            // Email
            else if (
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(matchText)
            ) {
                parts.push(
                    <a key={index} href={`mailto:${matchText}`}>
                        {matchText}
                    </a>
                );
            }

            // Phone
            else {
                parts.push(
                    <a
                        key={index}
                        href={`tel:${matchText.replace(/\s|-/g, "")}`}
                    >
                        {matchText}
                    </a>
                );
            }

            lastIndex = start + matchText.length;
        });

        // Remaining text
        if (lastIndex < text.length) {
            const remainingText = text.slice(lastIndex);

            remainingText.split("\n").forEach((line, i, arr) => {
                parts.push(line);

                if (i !== arr.length - 1) {
                    parts.push(<br key={`last-br-${i}`} />);
                }
            });
        }

        return parts;
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-genossenschaft" activePage='Impressum' sendTitle={false} />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-pink-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="pink" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.impressum-data" &&
                            <section className='sec-impressum sec-pink-color pt-pb-10'>
                                <div className="container">
                                    <div className='row'>
                                        <div className="col-left">
                                            <div className="imprsum-data">
                                                <div className='row line_center_vertical position-relative'>
                                                    {module?.Adresse_Data?.map((item, index) => (
                                                        <div key={index} className='col-md-6'>
                                                            <h3 className='fw-450 fs_30 text-darkgrey'>{item?.Title}</h3>
                                                            <ul className='no_disc'>
                                                                {item?.Icon_Text?.map((innerItem, i) => (
                                                                    <li key={i}>
                                                                        <span>
                                                                            <img src={`https://backend.bgzurlinden.ch${innerItem?.Icon?.url}`} alt="" />
                                                                        </span>
                                                                        {/* <div>{innerItem?.Text}</div> */}
                                                                        <div>{convertLinks(innerItem?.Text)}</div>
                                                                        {/* <address>Baugenossenschaft Zurlinden<br />Altstetterstrasse 335<br />CH-8047 Zürich</address> */}
                                                                    </li>
                                                                ))}


                                                            </ul>
                                                        </div>
                                                    ))}
                                                </div>
                                                <hr className='my-3 my-lg-4' style={{ backgroundColor: '#DADADA' }} />
                                                <p>© alle Rechte vorbehalten. Jegliche Verbreitung im Internet und jegliche andere Vervielfältigung, auch auszugsweise, nur mit ausdrücklicher Genehmigung des Herausgebers.</p>
                                            </div>
                                        </div>
                                        <div className="col-right mt-4 mt-lg-0">
                                            <div className='sec-bg-grey padd-equal'>
                                                <h3 className='text-pink fs_30 fw-700 mb-4'>{module?.Firme_Data?.Titel}</h3>
                                                <div className='imp_register_entry'>
                                                    {module?.Firme_Data?.Titel_Text?.map((item, index) => (
                                                        <>
                                                            <h3 className="fw-500 fs_26 text-darkgrey">{item?.Titel}</h3>
                                                            <p>{item?.Text}</p>
                                                            <hr className='my-3' style={{ backgroundColor: '#E2E2E2' }} />
                                                        </>
                                                    ))}
                                                    {/* <h3 className="fw-500 fs_26 text-darkgrey">Eingetragener Firmenname:</h3>
                                                    <p>Baugenossenschaft Zurlinden</p>
                                                    <hr className='my-3' style={{ backgroundColor: '#E2E2E2' }} />
                                                    <h3 className="fw-500 fs_26 text-darkgrey">Nummer:</h3>
                                                    <p>15296</p>
                                                    <hr className='my-3' style={{ backgroundColor: '#E2E2E2' }} />
                                                    <h3 className="fw-500 fs_26 text-darkgrey">Handelsregisteramt:</h3>
                                                    <p>Kanton Zürich</p>
                                                    <hr className='my-3' style={{ backgroundColor: '#E2E2E2' }} />
                                                    <h3 className="fw-500 fs_26 text-darkgrey">Mehrwertsteuernummer:</h3>
                                                    <p>CHE-101.043.509 MWST</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}


        </div>
    )
}